export default __webpack_public_path__ + "static/media/task.8c4563d6.svg";